import { useState, useEffect } from 'react';

export default function TopBar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Top Info Bar */}
      <div className="bg-slate-900 text-white py-2 px-4 text-xs md:text-sm">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <span className="flex items-center gap-1.5 text-amber-400 font-semibold">
              <i className="ri-award-fill" />
              18 Yıllık Tecrübe
            </span>
            <span className="hidden sm:block text-slate-500">|</span>
            <span className="flex items-center gap-1.5 text-slate-300">
              <i className="ri-map-pin-2-line text-sky-400" />
              İstanbul Anadolu Yakası • Yalova • Karamürsel • Kocaeli • İzmit
            </span>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="tel:05055600419"
              className="flex items-center gap-1.5 text-white hover:text-sky-400 transition-colors font-semibold whitespace-nowrap"
            >
              <i className="ri-phone-fill text-sky-400" />
              0505 560 04 19
            </a>
          </div>
        </div>
      </div>

      {/* Main Nav */}
      <nav
        className={`sticky top-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/eb02e9f867d09d1d36fd0cf7eb13e846.jpeg"
              alt="Evrensel Temizlik Hizmetleri Logo"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </a>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-6 text-sm font-medium">
            <a href="#hizmetler" className={`transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-sky-600' : 'text-white hover:text-sky-300'}`}>Hizmetler</a>
            <a href="#neden-biz" className={`transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-sky-600' : 'text-white hover:text-sky-300'}`}>Neden Biz?</a>
            <a href="#sss" className={`transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-sky-600' : 'text-white hover:text-sky-300'}`}>SSS</a>
            <a href="#iletisim" className={`transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-sky-600' : 'text-white hover:text-sky-300'}`}>İletişim</a>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="tel:05055600419"
              className="flex items-center gap-2 px-4 py-2 rounded-full border border-sky-500 text-sky-600 hover:bg-sky-50 transition-colors text-sm font-semibold whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              0505 560 04 19
            </a>
            <a
              href="https://wa.me/905055600419?text=Merhaba%2C%20temizlik%20hizmeti%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-2 px-5 py-2 rounded-full bg-sky-600 text-white hover:bg-sky-700 transition-colors text-sm font-semibold whitespace-nowrap"
            >
              <i className="ri-whatsapp-line" />
              WhatsApp
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            className={`md:hidden text-2xl ${isScrolled ? 'text-slate-800' : 'text-white'}`}
            aria-label="Menü"
          >
            <i className="ri-menu-line" />
          </button>
        </div>
      </nav>
    </>
  );
}
